import {
  AllTypeWidgets,
  BarCategoryWidgetTypes,
  LineCategoryWidgetTypes,
  PieCategoryWidgetTypes,
  TableCategoryWidgetTypes,
  TextCategoryWidgetTypes,
  TileCategoryWidgetTypes,
  WidgetCategory,
} from '../../types';
import BarWidget from './BarWidget/BarWidget';
import LineWidget from './LineWidget';
import PieWidget from './PieWidget';
import TableWidget from './TableWidget';
import TextWidget from './TextWidget';
import TileWidget from './TileWidget';

const RenderWidget = ({
  widget,
  setWidget,
  onSelect,
}: {
  widget: AllTypeWidgets;
  setWidget?: (v: AllTypeWidgets) => void;
  showBarGraphLabel?: boolean;
  onSelect?: (v: AllTypeWidgets) => void;
}) =>
  ({
    [WidgetCategory.Table]: <TableWidget widget={widget as TableCategoryWidgetTypes} setWidget={setWidget} onSelect={onSelect} />,
    [WidgetCategory.Pie]: <PieWidget widget={widget as PieCategoryWidgetTypes} onSelect={onSelect} />,
    [WidgetCategory.Bar]: <BarWidget widget={widget as BarCategoryWidgetTypes} onSelect={onSelect} />,
    [WidgetCategory.Line]: <LineWidget widget={widget as LineCategoryWidgetTypes} onSelect={onSelect} />,
    [WidgetCategory.Text]: <TextWidget widget={widget as TextCategoryWidgetTypes} />,
    [WidgetCategory.Tile]: <TileWidget widget={widget as TileCategoryWidgetTypes} onSelect={onSelect} />,
  })[widget.category];

export default RenderWidget;
